<template>
<v-card flat class="mt-4">
    <v-card-text>
        <p class="text-h6 text--primary mb-8">
            {{titleNotes}}
        </p>
        <v-data-table :headers="headersNotes" :items="itemListNotes" :hide-default-footer="true" :loading="isExporting" :items-per-page="itemListNotes.length">
            <!-- <template v-slot:item="{ item }">
                <tr>
                    <td v-html="formatContent(item.onsite.toString())"></td>

                    <td v-html="formatContent(item.assignment)"></td>

                    <td v-html="formatContent(item.recommendation)"></td>
                </tr>
            </template> -->
            <template v-slot:[`item.onsite`]="{ item }">
                <div style="height: 100%;">{{ item.onsite }}</div>
            </template>
            <template v-slot:[`item.assignment`]="{ item }">
                <div v-html="formatContent(item.assignment)"></div>
            </template>
            <template v-slot:[`item.recommendation`]="{ item }">
                <div v-html="formatContent(item.recommendation)"></div>
            </template>
        </v-data-table>
    </v-card-text>
</v-card>
</template>

<script>
export default {
    data() {
        return {
            search: "",
            options: {
                itemsPerPage: 20,
            },
            isExporting: false,
            titleNotes: 'เพิ่มเติม',
            headersNotes: [{
                    text: "Onsite",
                    value: "onsite",
                    align: 'center',
                    width: 100
                },
                {
                    text: "การบ้านจากโค้ช",
                    value: "assignment",
                    align: 'top'
                },
                {
                    text: "แนะนำเพิ่มเติม",
                    value: "recommendation",
                    align: 'top'
                }
            ],
            itemListNotes: []
        };
    },
    created() {
        (async () => {
            for (let i = 1; i <= this.programInfo['memberOnsite']; i++) {
                let assignmentValue = '-';
                let key = 'assignment';
                if (this.programInfo['onsite'] != undefined && this.programInfo['onsite']['onsite' + i] != undefined && this.programInfo['onsite']['onsite' + i][key] != undefined && this.programInfo['onsite']['onsite' + i][key] != '') {
                    assignmentValue = this.programInfo['onsite']['onsite' + i][key];
                }

                let recommendationValue = '';
                key = 'recommendation';
                if (this.programInfo['onsite'] != undefined && this.programInfo['onsite']['onsite' + i] != undefined && this.programInfo['onsite']['onsite' + i][key] != undefined && this.programInfo['onsite']['onsite' + i][key] != '') {
                    recommendationValue = this.programInfo['onsite']['onsite' + i][key];
                }

                const itemListHash = {
                    onsite: i,
                    assignment: assignmentValue,
                    recommendation: recommendationValue
                };
                this.itemListNotes.push(itemListHash);
            }
        })();
    },
    computed: {
        programInfo() {
            return this.$attrs.programInfo;
        }
    },
    methods: {
        formatContent(content) {
            return content !== undefined ? 
                content
                .replace(/\n/g, '<br>') // Replace newlines with <br> tags
                .replace(/\s/g, '&nbsp;') : '-'; // Replace spaces with non-breaking spaces
        },
    }
};
</script>
